import { render } from "./Objects.vue?vue&type=template&id=b3f98aae&scoped=true"
import script from "./Objects.vue?vue&type=script&lang=js"
export * from "./Objects.vue?vue&type=script&lang=js"

import "./Objects.vue?vue&type=style&index=0&id=b3f98aae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3f98aae"]])

export default __exports__